const data = [
	{
		en: "I declare that all the information provided in this form are correct and I bear full legal responsibility for the provided information.",
		ar: "أقر بأن جميع المعلومات المقدمة في هذا النموذج صحيحة وأتحمل المسؤولية القانونية الكاملة عن المعلومات المقدمة."
	},
	{
		en: "After the approval from RERA, payment for the valuation request should be done within 5 working days.",
		ar: "بعد موافقة مؤسسة التنظيم العقاري، يجب أن يتم دفع طلب التقييم في غضون 5 أيام عمل."
	},
	{
		en: "Valuation fees are non-refundable.",
		ar: "رسوم التقييم غير قابلة للاسترداد."
	},
	{
		en: "The Certificate is valid for one year from the date of issue.",
		ar: "الشهادة صالحة لمدة سنة واحدة من تاريخ إصدارها."
	}
];

export default data;
